import { FormControl } from '@mui/material';
import { getRatesOptions } from '@utriper/core';
import { SelectComponent } from '@utriper/core-ui';
import { useCurrency } from 'core/contexts/currency';
import { useTranslation } from 'react-i18next';

const MoneyDropDown = () => {
    const { t: translate } = useTranslation();

    const { currency, setCurrency } = useCurrency();

    const options = getRatesOptions().map((rate) => ({
        value: rate.name,
        name: rate.name,
        id: rate.name,
    }));

    return (
        <FormControl fullWidth>
            <SelectComponent
                values={options}
                value={currency}
                onChange={(e) => {
                    setCurrency(e.value);
                    window.localStorage.setItem('currency', e.value);
                }}
                label={translate('layout.appBar.currency')}
            />
        </FormControl>
    );
};

export default MoneyDropDown;
